import ProgressBarNota from '@componentsNew/Analises/ProgressBarNota';
import Typography from '@componentsNew/Typography';

function Nota({ tipo, nota }) {
  return (
    <div className="mb-8">
      <Typography component="h4-nota" className="mb-4">
        Média do desempenho em {tipo}
      </Typography>
      <ProgressBarNota nota={nota} />
    </div>
  );
}

export default Nota;
